"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
var vue_1 = require("vue");
var _withScopeId = function (n) { return (vue_1.pushScopeId("data-v-457fef80"), n = n(), vue_1.popScopeId(), n); };
var _hoisted_1 = { class: "header" };
var _hoisted_2 = { class: "header-back" };
var _hoisted_3 = { class: "header-title" };
var _hoisted_4 = { class: "header-close" };
var _hoisted_5 = { class: "body" };
var _hoisted_6 = {
    key: 0,
    class: "body-message"
};
var _hoisted_7 = { class: "message" };
var _hoisted_8 = { class: "message-info" };
var _hoisted_9 = { class: "message-cont" };
var _hoisted_10 = ["src"];
var _hoisted_11 = { key: 1 };
var _hoisted_12 = { class: "body-tab" };
var _hoisted_13 = ["onClick"];
var _hoisted_14 = { class: "tab-item-title" };
var _hoisted_15 = { class: "tab-item-count" };
var _hoisted_16 = { class: "body-list" };
var _hoisted_17 = ["src"];
var _hoisted_18 = { class: "name" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.show)
        ? (vue_1.openBlock(), vue_1.createElementBlock("div", {
            key: 0,
            class: vue_1.normalizeClass(["read-receipt", [_ctx.isH5 ? 'read-receipt-H5' : '', _ctx.isMenuOpen ? 'read-receipt-menu-open' : '']]),
            ref: "dialog"
        }, [
            vue_1.createElementVNode("div", _hoisted_1, [
                vue_1.createElementVNode("div", _hoisted_2, [
                    (_ctx.isH5)
                        ? (vue_1.openBlock(), vue_1.createElementBlock("i", {
                            key: 0,
                            class: "icon icon-back",
                            onClick: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                function () {
                                    var args = [];
                                    for (var _i = 0; _i < arguments.length; _i++) {
                                        args[_i] = arguments[_i];
                                    }
                                    return (_ctx.toggleShow && _ctx.toggleShow.apply(_ctx, args));
                                })
                        }))
                        : vue_1.createCommentVNode("", true)
                ]),
                vue_1.createElementVNode("div", _hoisted_3, [
                    vue_1.createElementVNode("span", null, vue_1.toDisplayString(_ctx.$t("TUIChat.消息详情")), 1)
                ]),
                vue_1.createElementVNode("div", _hoisted_4, [
                    (!_ctx.isH5)
                        ? (vue_1.openBlock(), vue_1.createElementBlock("i", {
                            key: 0,
                            class: "icon icon-close",
                            onClick: _cache[1] || (_cache[1] =
                                //@ts-ignore
                                function () {
                                    var args = [];
                                    for (var _i = 0; _i < arguments.length; _i++) {
                                        args[_i] = arguments[_i];
                                    }
                                    return (_ctx.toggleShow && _ctx.toggleShow.apply(_ctx, args));
                                })
                        }))
                        : vue_1.createCommentVNode("", true)
                ])
            ]),
            vue_1.createElementVNode("div", _hoisted_5, [
                (_ctx.isH5)
                    ? (vue_1.openBlock(), vue_1.createElementBlock("div", _hoisted_6, [
                        vue_1.createElementVNode("div", _hoisted_7, [
                            vue_1.createElementVNode("div", _hoisted_8, [
                                vue_1.createElementVNode("span", null, vue_1.toDisplayString(_ctx.message.from), 1),
                                vue_1.createElementVNode("span", null, vue_1.toDisplayString(_ctx.caculateTimeago(_ctx.message.time * 1000)), 1)
                            ]),
                            vue_1.createElementVNode("div", _hoisted_9, [
                                (_ctx.messageInfo.isImg)
                                    ? (vue_1.openBlock(), vue_1.createElementBlock("img", {
                                        key: 0,
                                        class: "message-cont-img",
                                        src: _ctx.messageInfo.content
                                    }, null, 8, _hoisted_10))
                                    : (vue_1.openBlock(), vue_1.createElementBlock("p", _hoisted_11, vue_1.toDisplayString(_ctx.messageInfo.content), 1))
                            ])
                        ])
                    ]))
                    : vue_1.createCommentVNode("", true),
                vue_1.createElementVNode("div", _hoisted_12, [
                    (vue_1.openBlock(true), vue_1.createElementBlock(vue_1.Fragment, null, vue_1.renderList(_ctx.readReceiptList, function (val, key) {
                        return (vue_1.openBlock(), vue_1.createElementBlock(vue_1.Fragment, null, [
                            (val.show)
                                ? (vue_1.openBlock(), vue_1.createElementBlock("div", {
                                    class: vue_1.normalizeClass(["tab-item", key === _ctx.showListNow && 'tab-item-now']),
                                    key: key,
                                    onClick: function ($event) { return (_ctx.showListNow = key); }
                                }, [
                                    vue_1.createElementVNode("div", _hoisted_14, vue_1.toDisplayString(val === null || val === void 0 ? void 0 : val.label), 1),
                                    vue_1.createElementVNode("div", _hoisted_15, vue_1.toDisplayString(val === null || val === void 0 ? void 0 : val.count), 1)
                                ], 10, _hoisted_13))
                                : vue_1.createCommentVNode("", true)
                        ], 64));
                    }), 256))
                ]),
                vue_1.createElementVNode("div", _hoisted_16, [
                    vue_1.createElementVNode("ul", null, [
                        (vue_1.openBlock(true), vue_1.createElementBlock(vue_1.Fragment, null, vue_1.renderList(_ctx.readReceiptList[_ctx.showListNow].userList, function (item, index) {
                            return (vue_1.openBlock(), vue_1.createElementBlock("li", {
                                key: index,
                                class: "body-list-item"
                            }, [
                                vue_1.createElementVNode("img", {
                                    class: "avatar",
                                    src: (item === null || item === void 0 ? void 0 : item.avatar) || 'https://image.iguopin.com/data/app/im-logo.png',
                                    onerror: "this.src='https://image.iguopin.com/data/app/im-logo.png'"
                                }, null, 8, _hoisted_17),
                                vue_1.createElementVNode("div", _hoisted_18, vue_1.toDisplayString((item === null || item === void 0 ? void 0 : item.nick) || (item === null || item === void 0 ? void 0 : item.userID)), 1)
                            ]));
                        }), 128))
                    ]),
                    (!_ctx.readReceiptList[_ctx.showListNow].isCompleted)
                        ? (vue_1.openBlock(), vue_1.createElementBlock("div", {
                            key: 0,
                            class: "more",
                            onClick: _cache[2] || (_cache[2] =
                                //@ts-ignore
                                function () {
                                    var args = [];
                                    for (var _i = 0; _i < arguments.length; _i++) {
                                        args[_i] = arguments[_i];
                                    }
                                    return (_ctx.getMoreList && _ctx.getMoreList.apply(_ctx, args));
                                })
                        }, " 查看更多 "))
                        : vue_1.createCommentVNode("", true)
                ])
            ])
        ], 2))
        : vue_1.createCommentVNode("", true);
}
exports.render = render;
